import { useMutation } from "react-query";
import inviteUserToOrg from "../services/inviteUserToOrg";

const useInviteUserToOrg = () => {
  return useMutation(["invite-user-to-org"], inviteUserToOrg);
};

export default useInviteUserToOrg;
